import { ca } from '@cian/analytics';
import { doOnceDecorator } from '@cian/valuation-utils-component';
import { ESpoilerCategoryRequest } from '../../../../types/offerHistory';

/** https://conf.cian.tech/pages/viewpage.action?pageId=1327402526 */

/** 1. Открытие подробностей об объявлении */
export function trackOfferFromHistoryShow() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: 'GoToOfferInModal_sopr',
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** 2. Скролл галереи с фотками */
export function trackOfferFromHistoryGalleryScroll() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: 'GalleryChangeImg_sopr',
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** 3. Ховер на информер "Как определяем похожие" */
export function trackNearbyOffersInfoClick() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: 'HowToDetectSimilary_sopr',
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** 4. Открытие фулскрин режима */
export const trackFullscreenViewOpen = doOnceDecorator(() => {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: 'GoToHistoryOffers',
    name: 'oldevent',
    useLastProducts: true,
  });
});

/** 5. Взаимодействия с фильтрами */
export function trackOffersHistoryFiltersChange(filters: string) {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: `OffersHistoryFilters_${filters}_sopr`,
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** 6. Клик на кнопку "Посмотреть объявление" */
export function trackRedirectToOfferClick() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: `GoToFullOffer_sopr`,
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** 7. Клик на фотографии объявления внутри модалки */
export function trackOfferFromHistoryGalleryClick() {
  ca('eventSite', {
    category: 'Card',
    action: 'Click',
    label: `OffersHistoryClickPhoto_sopr`,
    name: 'oldevent',
    useLastProducts: true,
  });
}

/** 8. Клик на табы категории в спойлере */
export function trackCategoryClick(category: ESpoilerCategoryRequest) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'EstateCalculator',
    label: `OffersHistoryFilters_${category}`,
  });
}

/** Teaser. Видимость точки входа в историю объявлений */
export function trackEntryIntoView() {
  ca('teaser', {
    product: {
      name: 'offers_history_entry_show',
    },
  });
}
